module.exports = __webpack_public_path__ + "5111b2ff1ae6f1bf98fc0e6461b39866.png";